/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  addEncoderSizePrefix,
  addDecoderSizePrefix,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Action (placeholder - use AuditAction) */
export type Action = {
  /** Action name */
  name: string;
};

export type ActionArgs = {
  /** Action name */
  name: string;
};

export function getActionEncoder(): Encoder<ActionArgs> {
  return getStructEncoder([
    ["name", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getActionDecoder(): Decoder<Action> {
  return getStructDecoder([
    ["name", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getActionCodec(): Codec<ActionArgs, Action> {
  return combineCodec(getActionEncoder(), getActionDecoder());
}
